import { PASSWORD_VALIDATION_OBJECT } from '@acorns/web-components'
import { BooleanSchema, StringSchema, boolean, object } from 'yup'

import { transformErrors } from 'utils/errors'
import { noSpecialCharacters } from 'utils/validation-schemas/helpers'

import { requiredString } from '../common/utils'
import { isClickId } from './form'

noSpecialCharacters()

export const validationErrorMap = new Map<string, string>([
  ['email', 'Please enter a valid email'],
  ['password', 'Please enter a valid password'],
  [
    'usResident',
    'To proceed, please confirm that you are a U.S. resident, at least 18 years old, and agree to the Program Agreement, Privacy Policy, and Auto Debit Authorization.',
  ],
  ['partnerDisclosure', 'You must read the partner referral disclosure to join Acorns'],
])

const emailValidationMessage = 'Please enter a valid email'
export const emailTypoMessage = (email: string) => `Did you mean ${email}?`
const emailMaxValidationMessage = 'Email must be ${max} characters or less.'

const checkboxValidationMessage = 'This field is required'

type ValidationSchema = {
  email: StringSchema
  password: StringSchema
  usResident: BooleanSchema
  partnerDisclosure?: BooleanSchema
}

// Handles Formik's validate event.
export const validate = (values, props) => {
  let errors = {}
  try {
    validationSchema(props).validateSync(values, { abortEarly: false })
  } catch (validationErrors) {
    // Convert validation errors to Formik errors collection
    errors = transformErrors(validationErrors.inner)
  }

  return errors
}

// Validation schema to be used by Formik.
export const validationSchema = ({ partner }) => {
  const schema: ValidationSchema = {
    email: requiredString()
      .email(emailValidationMessage)
      .max(65, emailMaxValidationMessage)
      .excludeSpecialCharacters(),
    password: PASSWORD_VALIDATION_OBJECT,
    usResident: boolean().oneOf([true], checkboxValidationMessage),
  }

  // If the customer is registering through a partner, the schema is extended
  // to include the "partnerDisclosure" field
  if (partner || isClickId()) {
    schema.partnerDisclosure = boolean().oneOf([true], checkboxValidationMessage)
  }

  return object().shape(schema)
}
